$ = require('jquery');
jQuery = $;
require('bootstrap');
require('../../../share/client/js/top.js');
require('../../../share/client/js/login.js');
require('../../../share/client/js/scrolltop.js');
require('../../../share/client/js/footer.js');
// require('./top.js');
require('../static/jquery.form.js');

window.uploads = function (file) {
    if (!file.files || !file.files[0]) {
        alert('读取文件失败');
        return;
    }
    var reader = new FileReader();
    reader.onload = function (evt) {
        $.ajax({
            type: 'get',
            async: false,
            url: ROOT + '/config/upload_path',
            data: {},
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                if (data !== undefined && data.message !== undefined) {
                    alert('获取上传地址失败:' + data.message);
                    return;
                }
                $('#add_upload').ajaxSubmit({
                    url: data,
                    type: 'post',
                    success: function (rs) {
                        if (rs !== undefined) {
                            if (rs.isOK == 1) {
                                var html = '';
                                html += '<div class="added_list_item">';
                                html += '<div class="shade-layer">';
                                html += '<img src="' + evt.target.result + '" style="width: 74px; height: 82px;" /></div>';
                                html += '<div class="added_item_delete">';
                                html += '<input type="hidden" class="attachment_name" value="' + rs.name + '" />';
                                html += '<input type="hidden" class="attachment_path" value="' + rs.relativepath + rs.name + '" />';
                                html += '</div>';
                                html += '</div>';

                                $('.added_list').append(html);
                            } else if (rs.errMessage !== undefined) {
                                console.log(rs.errMessage);
                                alert('图片上传失败:' + rs.errMessage);
                            } else {
                                console.log(rs);
                                alert('图片上传失败');
                            }
                        }

                        $('.added_item_delete').on('click', function () {
                            $(this).parent('.added_list_item').remove();
                        });
                    },
                    error: function (data) {
                        console.log(data);
                        alert('上传图片失败');
                    }
                });

            },
            error: function (data) {
                if (data.message !== undefined) {
                    console.log(data.message);
                    alert('上传失败:' + data.message);
                } else {
                    console.log(data);
                    alert('上传失败');
                }
            }
        });
    };
    reader.readAsDataURL(file.files[0]);
};


$(document).on('change', '#add-video-file', function (event) {
    var ele = $(this);
    var files = ele[0].files;

    if (!files || !files[0]) {
        return;
    }


    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/config/attachmentsuploader',
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data !== undefined && data.message !== undefined) {
                alert('获取视频上传地址失败:' + data.message);
                return;
            }

            var attachmentName = files[0].name;
            var html = '';
            html += '<div class="add-video-item">';
            html += '<div class="add-video-name">' + attachmentName + '</div>';
            html += '<div class="add-video-progress">0%</div>';
            html += '<div class="add-video-item-delete">';
            html += '<input type="hidden" class="video-attachment-name" value="" />';
            html += '<input type="hidden" class="video-attachment-path" value="" />';
            html += '</div>';
            html += '</div>';

            $('.add-video-list').html(html);

            var fd = new FormData();
            fd.append('onefile', files[0]);
            var xhr = new XMLHttpRequest();
            xhr.open('POST', data);
            // 进度条
            xhr.upload.onprogress = function (evt) {
                if (evt.lengthComputable) {
                    // evt.loaded：文件上传的大小   evt.total：文件总的大小
                    // 加载进度条，同时显示信息
                    var percentComplete = (evt.loaded) * 100.0 / evt.total;

                    var loaded = evt.loaded;
                    var tot = evt.total;
                    var per = Math.floor(100 * loaded / tot); // 已经上传的百分比
                    $('.add-video-progress').text(per + '%');

                    // xhr.abort();
                }
            };

            // 上传完成
            xhr.onload = function (data) {
                var jsonStr = data.target.responseText;
                jsonStr = eval('(' + jsonStr + ')');
                if (jsonStr != null && jsonStr.isOK) {
                    // jsonStr.relativepath + jsonStr.files[i].name

                    $('.video-attachment-name').val(jsonStr.name);
                    $('.video-attachment-path').val(jsonStr.relativepath + jsonStr.name);

                    $('.add-video-progress').text('视频上传完成');

                    $('.add-video-item-delete').on('click', function () {
                        $(this).parent('.add-video--item').remove();
                    });
                } else {
                    alert('视频上传失败');
                }
                if (xhr.status === 200 && xhr.readyState == 4) {

                }
            };

            // 上传失败
            xhr.onerror = function (evt) {
                alert('视频上传失败');
            };

            xhr.abort = function () {
                console.log('abort!!');
            };

            xhr.send(fd);

        },
        error: function (data) {
            if (data.message !== undefined) {
                console.log(data.message);
                alert('上传失败:' + data.message);
            } else {
                console.log(data);
                alert('上传失败');
            }
        }
    });
});

window.getAttachment = function (id, w, h) {
    if (id === undefined || id == '') {
        return;
    }
    if (w === undefined || w == null || isNaN(parseInt(w))) {
        w = 120;
    }
    if (w === undefined || w == null || isNaN(parseInt(h))) {
        h = 120;
    }
    var size = '?w=' + w + '&h=' + h + '&s=3';

    var data = {
        id: id
    };

    $.ajax({
        type: 'post',
        async: false,
        url: ROOT + '/config/attachments',
        data: JSON.stringify(data),
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data.message !== undefined) {
                console.log(data);
                return;
            }

            for (var i = 0; i < data.length; i++) {
                if (data[i].type == 1) {
                    $('img[src="' + data[i].id + '"]').attr('src', data[i].url + '?w=525&h=525&s=3');
                    // $('img[src="' + data[i].id + '"]').attr('src', data[i].url + size);
                } else if (data[i].type == 2) {
                    $('img[src="box-' + data[i].id + '"]').remove();
                    $('img[src="' + data[i].id + '"]').parent().parent().parent().data('type', 2);
                    $('img[src="' + data[i].id + '"]').parent().parent().parent().data('url', data[i].url);
                    $('img[src="' + data[i].id + '"]').parent().parent().parent().attr('id', 'video-' + data[i].id);

                    $('img[src="' + data[i].id + '"]').parent().parent().addClass('thread-video');
                    $('img[src="' + data[i].id + '"]').parent().parent().append('<div class="video-preview"></div>');

                    $('img[src="' + data[i].id + '"]').attr('src', data[i].thumbnail_url);
                } else {
                    $('img[src="' + data[i].id + '"]').remove();
                }
            }
        },
        error: function (data) {
            console.log(data);
            // if (data.message !== undefined)
            //    alert('获取附件失败:' + data.message);
            // else
            //    alert('获取附件失败:' + data);
        }
    });
};

window.GetQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
};

window.imageClick = function (item) {
    if (item.length == 0) {
        return;
    }

    $('.nav-img.selected').removeClass('selected');
    item.addClass('selected');
    var url = item.children().attr('src');
    if (url.indexOf('?') > 0) {
        url = url.substr(0, url.indexOf('?'));
    }
    $('.big-img img').attr('src', url);
};

window.LastImage = function () {
    imageClick($('.nav-img.selected').prev());
};

window.NextImage = function () {
    imageClick($('.nav-img.selected').next());
};

$('.big-img').on('mousemove', function (event) {
    var x = event.offsetX;
    if (x < $('.big-img').width() / 2) {
        $('.big-img').removeClass('mouseright');
        $('.big-img').addClass('mouseleft');
    } else {
        $('.big-img').removeClass('mouseleft');
        $('.big-img').addClass('mouseright');
    }
});

$('.big-img').on('click', function (event) {
    if ($('.big-img').hasClass('mouseleft')) {
        imageClick($('.nav-img.selected').prev());
    } else if ($('.big-img').hasClass('mouseright')) {
        imageClick($('.nav-img.selected').next());
    }
});

$('.nav-img').on('click', function () {
    if ($(this).hasClass('selected')) {
        return;
    }
    imageClick($(this));
});

window.GetQRCode = function (id) {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/config/getappurl',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data.message !== undefined) {
                console.log(data);
                return;
            }
            var qrcode = new QRCode(document.getElementById('qrcode'), {
                text: data.android_download_url,
                width: 128,
                height: 128,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            });
        },
        error: function (data) {
            console.log(data);
            // if (data.message !== undefined)
            //    alert('获取附件失败:' + data.message);
            // else
            //    alert('获取附件失败:' + data);
        }
    });
};

$(window).scroll(function () {
    // scrollTop是浏览器滚动条的top位置，
    // var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // var overheight = 82;
    //
    // if (scrollTop < overheight) {
    //     var top = overheight - scrollTop;
    //     $('.left').css('top', top + 'px');
    // } else {
    //     $('.left').css('top', '0px');
    // }

    $('.left-bg').height($('.middle').height());
});

